import React from 'react';
import PropTypes from 'prop-types';

import { BaseDialog, CodeSquare01Icon } from '@metarouter-private/mr-mui';

import MODAL_VIEWS from './MODAL_VIEWS';
import useManageSampleEventsModal from './useManageSampleEventsModal';
import ListView from './ListView';
import EditView from './EditView';
import ConfirmDeleteView from './ConfirmDeleteView';

export default function ManageSampleEventsModal({ open, onClose, onSampleEventChange }) {
  const {
    currentView,
    selectedSampleEvent,
    goToEditView,
    goToDeleteView,
    goToListView,
    onEditSuccess,
    onDeleteSuccess,
    onModalClosed,
  } = useManageSampleEventsModal({ onSampleEventChange });

  function renderContent() {
    switch (currentView) {
      case MODAL_VIEWS.LIST:
        return <ListView onEdit={goToEditView} onDelete={goToDeleteView} />;
      case MODAL_VIEWS.EDIT:
        return (
          <EditView sampleEventId={selectedSampleEvent.id} onCancel={goToListView} onEditSuccess={onEditSuccess} />
        );
      case MODAL_VIEWS.DELETE_CONFIRM:
        return (
          <ConfirmDeleteView
            sampleEvent={selectedSampleEvent}
            onCancel={goToListView}
            onDeleteSuccess={onDeleteSuccess}
          />
        );
      default:
        return null;
    }
  }

  return (
    <BaseDialog
      DialogProps={{
        open,
        onClose,
        maxWidth: 'md',
        fullWidth: true,
        TransitionProps: {
          onExited: onModalClosed,
        },
      }}
      title="Sample Events"
      TitleIcon={CodeSquare01Icon}
      content={renderContent()}
    />
  );
}

ManageSampleEventsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSampleEventChange: PropTypes.func.isRequired,
};
